/* eslint-disable  */
import React, { useState } from "react";
import {
  Home,
  HandCoins,
  TrendingUp,
  Banknote,
  BookOpen,
  CheckCircle2,
  Receipt,
  Archive,
  Users,
  UserCog,
  BarChart3,
  FileText,
  LogOut,
  Menu,
  X,
  Bell,
  MessageSquare,
  ChevronLeft,
  Shield,
} from "lucide-react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import ThemeToggle from "../Components/ThemeToggle";
import { SignOut } from "../services/Actions/authActions";
import "./AdminDashboard.css";

const menuItems = [
  { label: "Dashboard", icon: Home, path: "/admin/home" },
  { label: "Funds Deduction", icon: HandCoins, path: "/admin/funds" },
  { label: "Fund Increment", icon: TrendingUp, path: "/admin/fund-increment" },
  { label: "Loan Deduction", icon: Banknote, path: "/admin/loans" },
  { label: "Initiated Loans", icon: BookOpen, path: "/admin/loans-bookings" },
  { label: "Paid Loans", icon: CheckCircle2, path: "/admin/loans-paid" },
  { label: "Dues Deduction", icon: Receipt, path: "/admin/dues" },
  { label: "Archives", icon: Archive, path: "/admin/archives" },
  { label: "UPNMG Members", icon: Users, path: "/admin/members" },
  { label: "System Users", icon: UserCog, path: "/admin/users" },
  { label: "Charts", icon: BarChart3, path: "/admin/charts" },
  { label: "Report", icon: FileText, path: "/admin/report", divider: true },
];

function RenderAdminPage({ children, title }) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    dispatch(SignOut());
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
  };

  const isActive = (path) => location.pathname === path;

  // Get display name: use email prefix if name looks like a role/code
  const getDisplayName = () => {
    const name = user?.name;
    if (name && /^[A-Z_]+$/.test(name)) {
      // Name is all caps/underscores (like a role code), use email instead
      if (user?.email) {
        return user.email.split("@")[0];
      }
    }
    return name?.split(" ")[0] || "Admin";
  };

  const getDisplayRole = () => {
    const role = user?.super_role || user?.role;
    if (!role) return "Admin";
    return role
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  return (
    <div className={`admin-layout ${collapsed ? "sidebar-collapsed" : ""}`}>
      {mobileOpen && (
        <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${mobileOpen ? "mobile-open" : ""}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <Shield size={24} className="brand-icon" />
            {!collapsed && <span className="brand-text">Super Admin</span>}
          </div>
          <button
            className="collapse-btn hidden-mobile"
            onClick={() => setCollapsed(!collapsed)}
          >
            <ChevronLeft
              size={18}
              style={{
                transform: collapsed ? "rotate(180deg)" : "none",
                transition: "transform 0.3s",
              }}
            />
          </button>
          <button
            className="collapse-btn show-mobile"
            onClick={() => setMobileOpen(false)}
          >
            <X size={18} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <React.Fragment key={item.path}>
              {item.divider && <div className="sidebar-divider" />}
              <div
                className={`sidebar-menu-item ${isActive(item.path) ? "active" : ""}`}
                onClick={() => {
                  history.push(item.path);
                  setMobileOpen(false);
                }}
                title={collapsed ? item.label : ""}
              >
                <item.icon size={19} className="menu-icon" />
                {!collapsed && <span className="menu-label">{item.label}</span>}
              </div>
            </React.Fragment>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-menu-item logout-item" onClick={handleLogout}>
            <LogOut size={19} className="menu-icon" />
            {!collapsed && <span className="menu-label">Logout</span>}
          </div>
          {!collapsed && (
            <div className="sidebar-user">
              <div className="user-avatar">
                {getDisplayName().charAt(0).toUpperCase()}
              </div>
              <div className="user-info">
                <div className="user-name">{getDisplayName()}</div>
                <div className="user-role">{getDisplayRole()}</div>
              </div>
            </div>
          )}
        </div>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <header className="admin-topbar">
          <div className="topbar-left">
            <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)}>
              <Menu size={22} />
            </button>
            <h1 className="page-title">{title}</h1>
          </div>
          <div className="topbar-right">
            <ThemeToggle />
            <button className="topbar-icon-btn">
              <MessageSquare size={20} />
            </button>
            <button className="topbar-icon-btn">
              <Bell size={20} />
            </button>
          </div>
        </header>

        <div className="admin-content">{children}</div>
      </main>
    </div>
  );
}

export default RenderAdminPage;
